class SliderImage{
    constructor(json){
        this.id=json.id;
        this.title=json.title;
        this.url=json.url;
        this.img=json.img;
        this.type=json.type;
        this.stores_id=json.stores_id;
        this.product_id=json.product_id;
        this.serivce_id=json.serivce_id;
    }
}

export default SliderImage;